import { useCallback, useEffect, useMemo, useState } from 'react';
import { DemoInsights, DemoMatch } from 'types/demos';
import { fetchDemoMatches } from 'services/demoMatchesService';
import { calculateDemoInsights } from 'utils/demoInsights';

interface DemoMatchesState {
    matches: DemoMatch[];
    insights: DemoInsights;
    loading: boolean;
    error?: string;
    refresh: () => void;
}

export const useDemoMatches = (): DemoMatchesState => {
    const [matches, setMatches] = useState<DemoMatch[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>();
    const [refreshIndex, setRefreshIndex] = useState(0);

    const loadMatches = useCallback(async () => {
        setLoading(true);
        try {
            const payload = await fetchDemoMatches();
            setMatches(payload);
            setError(undefined);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Tuntematon virhe');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadMatches();
    }, [loadMatches, refreshIndex]);

    const refresh = () => setRefreshIndex((value) => value + 1);

    const insights = useMemo(() => calculateDemoInsights(matches), [matches]);

    return {
        matches,
        loading,
        error,
        insights,
        refresh,
    };
};

export default useDemoMatches;
